<script lang="ts">
import GenericButton from "@/Components/Generics/GenericButton.vue";
import Plane from "@/Components/Generics/Plane.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        Plane,
        GenericButton,
    },
    props: {},
    emits: ["closed"],
    data: () => ({
        visible: false,
    }),
    computed: {},
    mounted() {
        this.visible = true;
    },
    methods: {
        close(): void {
            this.visible = false;
        },
        onAfterLeave(): void {
            this.$emit("closed");
        },
    },
});
</script>

<template>
    <Teleport to="#modal-wrapper">
        <Transition name="modal-close-transition" @after-leave="onAfterLeave">
            <div v-if="visible" class="modal-wrapper" @click.stop="close">
                <Plane class="modal-plane">
                    <div class="flex flex--v flex--valign-c flex--gap-30">
                        <div class="flex flex--valign-c flex--halign-c flex--gap-10">
                            <span class="text text--size-14 text--primary-b">&bull;</span>
                            <span class="text text--size-18 text--semi-bold text--primary-b text--uppercase">
                                <slot name="title">No title</slot>
                            </span>
                            <span class="text text--size-14 text--primary-b">&bull;</span>
                        </div>

                        <slot name="content">No Content</slot>

                        <div class="modal-plane-buttons flex flex--valign-c flex--gap-15 flex--halign-c" @click.stop="close">
                            <slot name="buttons">
                                <GenericButton :title="$trans('acp.close')" :circular="true" @click.stop="close" />
                            </slot>
                        </div>
                    </div>
                </Plane>
            </div>
        </Transition>
    </Teleport>
</template>

<style lang="scss" scoped>
.modal-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    // background-color: #0008;
    pointer-events: all;

    .modal-plane {
        position: absolute;
        top: 50%;
        left: 50%;
        // transform: translate(-50%, -50%);
        // opacity: 1;
        max-width: rem(800);

        .modal-plane-buttons {
            margin-bottom: rem(-10);
        }
    }
}

@include media-breakpoint-down(md) {
    .modal-wrapper {
        .modal-plane {
            .modal-plane-buttons {
                flex-direction: row;
            }
        }
    }
}
</style>
